/**
 * @file Renders the masked six-digit verification code input.
 */
import React from "react";
import { MaskedInput } from "antd-mask-input";

import { W1 } from "@components/Constants";

const MASK = "000000";

type Props = {
  onChange: (value: string) => void;
}

type MaskedInputData = {
  unmaskedValue: string;
}

/**
 * Renders the masked six-digit code input.
 */
const VerificationCodeInput = ({ onChange }: Props) => {
  /**
   * Extracts the unmasked digits and reports them to the caller.
   */
  const handleChange = (input: MaskedInputData) => {
    const { unmaskedValue } = input;
    onChange(unmaskedValue);
  };

  return (
    <div style={{ marginTop: W1, marginBottom: W1 }}>
      <MaskedInput
        size="large"
        mask={MASK}
        style={{ width: 90, textAlign: "center" }}
        onChange={handleChange}
      />
    </div>
  );
};

export default VerificationCodeInput;
